import {Connection, ConnectionType} from '@flowmaps-com/flowmaps-typescriptmodels';
import {linkedElectricityConnectionId} from './intermediate-meter.utils';

export function canCalculateResidual(connectionTotalAuthorized?: boolean): boolean {
    return connectionTotalAuthorized !== false;
}

export function calculatedResidualLabel(configuredLabel: string | undefined,
                                        translatedUnallocatedLabel: string): string {
    return configuredLabel || translatedUnallocatedLabel;
}

export function belongsToResidualConnection(parentConnectionId?: string,
                                            childConnectionId?: string): boolean {
    return !parentConnectionId || parentConnectionId === childConnectionId;
}

export function residualConnectionId(connection?: Connection,
                                     locationConnections: Connection[] = []): string | undefined {
    if (!connection) return undefined;
    if (connection.info?.connectionType === ConnectionType.ChargePoint) {
        return linkedElectricityConnectionId(connection, locationConnections) || connection.connectionId;
    }
    return connection.connectionId;
}

export function calculateResidualSeries(mainTotal: number[], allocatedSeries: number[][]): number[] {
    return mainTotal.map((total, index) => (allocatedSeries || []).reduce(
        (remainder, series) => Math.max(remainder - Number(series?.[index] || 0), 0), Number(total || 0)));
}
